const temp = [
-0.17,
-0.09,
-0.11,
-0.18,
-0.28,
-0.33,
-0.31,
-0.36,
-0.17,
-0.1,
-0.35,
-0.22,
-0.27,
-0.32,
-0.32,
-0.23,
-0.11,
-0.11,
-0.27,
-0.18,
-0.08,
-0.16,
-0.28,
-0.37,
-0.47,
-0.26,
-0.22,
-0.39,
-0.43,
-0.48,
-0.43,
-0.44,
-0.36,
-0.34,
-0.15,
-0.14,
-0.36,
-0.46,
-0.3,
-0.28,
-0.27,
-0.19,
-0.29,
-0.27,
-0.27,
-0.22,
-0.11,
-0.22,
-0.2,
-0.36,
-0.16,
-0.09,
-0.15,
-0.28,
-0.12,
-0.2,
-0.14,
-0.02,
0.0,
-0.01,
0.13,
0.19,
0.07,
0.09,
0.21,
0.09,
-0.07,
-0.02,
-0.1,
-0.11,
-0.17,
-0.07,
0.01,
0.08,
-0.13,
-0.14,
-0.19,
0.05,
0.06,
0.03,
-0.03,
0.06,
0.03,
0.05,
-0.2,
-0.11,
-0.06,
-0.02,
-0.08,
0.05,
0.02,
-0.08,
0.01,
0.16,
-0.07,
-0.01,
-0.1,
0.18,
0.07,
0.16,
0.26,
0.32,
0.14,
0.31,
0.16,
0.12,
0.18,
0.32,
0.39,
0.27,
0.45,
0.4,
0.22,
0.23,
0.32,
0.45,
0.33,
0.46,
0.61,
0.38,
0.39,
0.53,
0.63,
0.62,
0.53,
0.67,
0.63,
0.66,
0.54,
0.65,
0.72,
0.61,
0.65,
0.67,
0.74,
0.89,
1.01,
0.92,
0.85,
0.98,
1.02,
0.84,

]

export default temp